import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FrmSolicitudComponent } from './frm-solicitud.component';
import {
  DxButtonModule, DxCheckBoxModule, DxDateBoxModule, DxSelectBoxModule, DxTextAreaModule, DxTextBoxModule,
  DxValidationSummaryModule,
  DxValidatorModule
} from "devextreme-angular";
import {RouterModule} from "@angular/router";
import { ReCaptchaModule } from 'angular2-recaptcha';

@NgModule({
  imports: [
    CommonModule, RouterModule,
    DxSelectBoxModule,
    DxCheckBoxModule,
    DxTextBoxModule,
    DxDateBoxModule,
    DxButtonModule,
    DxValidatorModule,
    DxValidationSummaryModule,
    DxTextAreaModule,
    ReCaptchaModule,
  ],
  declarations: [FrmSolicitudComponent],
  exports: [FrmSolicitudComponent]
})
export class FrmSolicitudModule { }



// WEBPACK FOOTER //
// ./src/app/layouts/frm-solicitud/frm-solicitud.module.ts